//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import * as React from "react";
import { RedocStandalone } from "redoc";
import { REDOC_THEME } from "src/common/constant";

export interface IModulesComponentProps {
    yamlFile: any;
}

export class ModulesComponent extends React.Component<IModulesComponentProps, any> {
    render() {
        return (
            <div>
                    <RedocStandalone
                        specUrl={JSON.parse(JSON.stringify(this.props.yamlFile))}
                        options={{
                            nativeScrollbars: true,
                            theme: REDOC_THEME,
                        }}
                    />
            </div>
        )
    }
}

export default ModulesComponent;
